import React from 'react';
import { Eye, Download, Share2 } from 'lucide-react';
export function LabelPreviewCard() {
  return <div className="bg-white rounded-lg border" data-id="element-343">
      <div className="p-6 border-b border-gray-200" data-id="element-344">
        <div className="flex items-center justify-between" data-id="element-345">
          <div data-id="element-346">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-347">
              Label Preview
            </h2>
            <p className="text-sm text-gray-600 mt-1" data-id="element-348">
              Front and back label design with required elements
            </p>
          </div>
          <div className="flex items-center space-x-3" data-id="element-349">
            <button className="flex items-center space-x-2 px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg" data-id="element-350">
              <Download className="w-4 h-4" data-id="element-351" />
              <span data-id="element-352">Export</span>
            </button>
            <button className="flex items-center space-x-2 px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg" data-id="element-353">
              <Eye className="w-4 h-4" data-id="element-354" />
              <span data-id="element-355">Full View</span>
            </button>
          </div>
        </div>
      </div>
      <div className="p-6 flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-6" data-id="element-356">
        {/* Front Label Preview */}
        <div className="flex-1" data-id="element-357">
          <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-358">
            Front Label
          </h3>
          <div className="relative border border-gray-200 rounded-lg overflow-hidden bg-gray-50 aspect-[2/3] flex items-center justify-center" data-id="element-359">
            <div className="w-3/4 h-4/5 bg-white border border-gray-300 rounded-md flex flex-col items-center justify-between p-4 text-center shadow-sm" data-id="element-360">
              <div className="space-y-1" data-id="element-361">
                <div className="text-xs uppercase tracking-wider text-gray-500" data-id="element-362">
                  Sonoma Valley Vineyards
                </div>
                <div className="text-xl font-serif font-bold mt-2" data-id="element-363">
                  ESTATE RESERVE
                </div>
                <div className="text-2xl font-serif font-bold" data-id="element-364">
                  CABERNET SAUVIGNON
                </div>
                <div className="text-sm mt-2" data-id="element-365">2019</div>
              </div>
              <div className="my-4 flex-grow flex items-center justify-center" data-id="element-366">
                <img src="https://images.unsplash.com/photo-1586370434639-0fe43b2d32e6?w=250&h=250&fit=crop&crop=center" alt="Wine bottle" className="max-h-full object-contain" data-id="element-367" />
              </div>
              <div className="space-y-1" data-id="element-368">
                <div className="text-xs" data-id="element-369">ALEXANDER VALLEY</div>
                <div className="text-xs" data-id="element-370">SONOMA COUNTY, CALIFORNIA</div>
                <div className="text-xs mt-2" data-id="element-371">750ML • 14.5% ALC/VOL</div>
                <div className="text-[10px] mt-1" data-id="element-372">CONTAINS SULFITES</div>
              </div>
            </div>
            <div className="absolute top-2 right-2 flex space-x-1" data-id="element-373">
              <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center" title="TTB Approved" data-id="element-374">
                <span className="text-green-800 text-xs" data-id="element-375">✓</span>
              </div>
            </div>
          </div>
          <div className="mt-2 text-xs text-gray-500" data-id="element-376">
            TTB Application ID: 21-234567
          </div>
        </div>
        {/* Back Label Preview */}
        <div className="flex-1" data-id="element-377">
          <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-378">Back Label</h3>
          <div className="relative border border-gray-200 rounded-lg overflow-hidden bg-gray-50 aspect-[2/3] flex items-center justify-center" data-id="element-379">
            <div className="w-3/4 h-4/5 bg-white border border-gray-300 rounded-md flex flex-col p-4 shadow-sm" data-id="element-380">
              <div className="text-xs leading-snug space-y-3" data-id="element-381">
                <p className="font-medium" data-id="element-382">GOVERNMENT WARNING:</p>
                <p className="text-[9px]" data-id="element-383">
                  (1) According to the Surgeon General, women should not drink
                  alcoholic beverages during pregnancy because of the risk of
                  birth defects.
                </p>
                <p className="text-[9px]" data-id="element-384">
                  (2) Consumption of alcoholic beverages impairs your ability to
                  drive a car or operate machinery, and may cause health
                  problems.
                </p>
                <div className="border-t border-gray-200 pt-3" data-id="element-385">
                  <p data-id="element-386">
                    Our Estate Reserve Cabernet Sauvignon is crafted from grapes
                    grown in our Alexander Valley vineyards. Aged for 18 months
                    in French oak barrels, this wine exhibits rich flavors of
                    black currant, dark cherry, and hints of vanilla and spice.
                  </p>
                </div>
                <div className="border-t border-gray-200 pt-3" data-id="element-387">
                  <p className="font-medium" data-id="element-388">CONTAINS SULFITES</p>
                  <p data-id="element-389">Vegan Friendly • Sustainably Farmed</p>
                </div>
                <div className="border-t border-gray-200 pt-3 text-center" data-id="element-390">
                  <p data-id="element-391">PRODUCED AND BOTTLED BY</p>
                  <p className="font-medium" data-id="element-392">SONOMA VALLEY VINEYARDS</p>
                  <p data-id="element-393">SONOMA, CALIFORNIA • USA</p>
                </div>
              </div>
            </div>
            <div className="absolute top-2 right-2 flex space-x-1" data-id="element-394">
              <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center" title="TTB Approved" data-id="element-395">
                <span className="text-green-800 text-xs" data-id="element-396">✓</span>
              </div>
            </div>
          </div>
          <div className="mt-2 text-xs text-gray-500" data-id="element-397">
            TTB Approval Date: 03/15/2021
          </div>
        </div>
      </div>
    </div>;
}